import { Controller } from "@hotwired/stimulus"
import lottie from "lottie-web"

export default class extends Controller {
  static targets = ["animation", "haptic"]
  static values = { animation: String }

  connect() {
    this.showCelebration()
  }

  showCelebration() {
    this.element.showModal()

    this.animation = lottie.loadAnimation({
      container: this.animationTarget,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: this.animationValue
    })

    // Trigger haptic feedback after a short delay to sync with animation
    setTimeout(() => {
      this.triggerHapticFeedback()
    }, 500)

    this.animation.addEventListener('complete', () => {
      setTimeout(() => {
        this.closeCelebration()
      }, 1000)
    })
  }

  closeCelebration() {
    if (this.animation) {
      this.animation.destroy()
      this.animation = null
    }

    this.element.close()

    setTimeout(() => {
      this.element.remove()
    }, 100)
  }

  triggerHapticFeedback() {
    // Multiple vibrations for a more celebratory feel
    if (this.hasHapticTarget) {
      this.hapticTarget.click()
      setTimeout(() => this.hapticTarget.click(), 200)
      setTimeout(() => this.hapticTarget.click(), 400)
    }
  }
}
